export const APIConstant = {
    login: {
        getLocalStorage: 'Client/getLocalStorage?userId=',
        checkLogin: 'Sec/Login',
        verifywithEmail: 'Sec/VerifywithEmail'
    },
    header: {
        getProjectMenu: 'Project/GetSecUserProjectMenu?projectId=',
        getAdmin:'Client/GetUserAccessByUser?Email='
    },
    settings:{
        getChangePasswordConstant:'Sec/changePassword'
    },
    tryNow:{
        getTryNowConstant:'Client/SelectTryNowData',
        getUpdateTryNowConstant:'Client/UpdateTryNowData',
        getSaveTryNowConstant:'Client/SaveFileContent',
        getFetchTryNowConstant:'Client/FetchFileContent?path=',
        getFetchTryNowFile:'Client/GetTryNowFile',
        getSaveTryNowFile: 'Client/SaveTryNowFile',
        getTryNowMail: 'Client/TryNowMail',
        getSendSimpleMailConstant: 'Client/SendSimpleMail',
    },
    resetPassword:{
        getOTP:'AAD/pwdreset?mail=',
        otpCheck:'AAD/otpcheck?mail=',
        getresetPassword:'Sec/ResetPassword'
    }
}